// TeleRex Double Walled Corrugated PE Pipes for Signalling, Telecom & Power Cable Protection
// HSN CODE: 39172190

export const telerexCatalog = {
    title: "ASTRAL TELEREX - DOUBLE WALLED CORRUGATED PE PIPES FOR CABLE PROTECTION",
    hsn_code: "39172190",
    certification: "IS:16205 (Part-24)",
    description: "Double walled corrugated PE pipes for signalling, telecom & power cable protection",

    // 450N Inner Wavy 100M ORG/ORG with RR
    n450_wavy_100m_rr: [
        { size: "4.0/40", code: "A123040C0100E", price: 39 }, { size: "5.0/50", code: "A123050C0100E", price: 60 },
        { size: "6.3/63", code: "A123063C0100E", price: 90 }
    ],
    // 450N Inner Wavy 100M ORG/ORG with NFP
    n450_wavy_100m_nfp: [
        { size: "4.0/40", code: "A131040C0100E", price: 44 }, { size: "5.0/50", code: "A131050C0100E", price: 63 },
        { size: "6.3/63", code: "A131063C0100E", price: 95 }
    ],
    // 450N Inner Plain 100M ORG/ORG with RR
    n450_plain_100m_rr: [
        { size: "4.0/40", code: "A121040C0100E", price: 41 }, { size: "5.0/50", code: "A121050C0100E", price: 71 },
        { size: "6.3/63", code: "A121063C0100E", price: 101 }
    ],
    // 450N Inner Plain 100M ORG/ORG with NFP
    n450_plain_100m_nfp: [
        { size: "4.0/40", code: "A127040C0100E", price: 46 }, { size: "5.0/50", code: "A127050C0100E", price: 79 },
        { size: "6.3/63", code: "A127063C0100E", price: 112 }
    ],
    // 450N Inner Plain 6M ORG/ORG with NFP
    n450_plain_6m_nfp: [
        { size: "4.0/40", code: "A127040C0006E", price: 46 }, { size: "5.0/50", code: "A127050C0006E", price: 77 },
        { size: "6.3/63", code: "A127063C0006E", price: 101 }, { size: "7.5/75", code: "A127075C0006E", price: 123 },
        { size: "7.7/77", code: "A127077C0006E", price: 132 }, { size: "9.0/90", code: "A127090C0006E", price: 165 },
        { size: "11.0/110", code: "A127110C0006E", price: 216 }, { size: "12.0/120", code: "A127120C0006E", price: 220 },
        { size: "16.0/160", code: "A127160C0006E", price: 352 }, { size: "17.5/175", code: "A127175C0006E", price: 430 },
        { size: "18.0/180", code: "A127180C0006E", price: 429 }, { size: "20.0/200", code: "A127200C0006E", price: 495 },
        { size: "25.0/250", code: "A127250C0006E", price: 743 }, { size: "31.5/315", code: "A127315C0006E", price: 1095 }
    ],
    // 450N Inner Plain 6M ORG/ORG with RR & NFP
    n450_plain_6m_rr_nfp: [
        { size: "4.0/40", code: "A108040C0006E", price: 50 }, { size: "5.0/50", code: "A108050C0006E", price: 79 },
        { size: "6.3/63", code: "A108063C0006E", price: 112 }, { size: "7.5/75", code: "A108075C0006E", price: 128 },
        { size: "7.7/77", code: "A108077C0006E", price: 138 }, { size: "9.0/90", code: "A108090C0006E", price: 173 },
        { size: "11.0/110", code: "A108110C0006E", price: 224 }, { size: "12.0/120", code: "A108120C0006E", price: 242 },
        { size: "16.0/160", code: "A108160C0006E", price: 386 }, { size: "17.5/175", code: "A108175C0006E", price: 473 },
        { size: "18.0/180", code: "A108180C0006E", price: 472 }, { size: "20.0/200", code: "A108200C0006E", price: 544 },
        { size: "25.0/250", code: "A108250C0006E", price: 815 }, { size: "31.5/315", code: "A108315C0006E", price: 1202 }
    ],
    // 750N Inner Wavy 100M ORG/ORG with RR
    n750_wavy_100m_rr: [
        { size: "4.0/40", code: "A124040C0100E", price: 60 }, { size: "5.0/50", code: "A124050C0100E", price: 98 },
        { size: "6.3/63", code: "A124063C0100E", price: 138 }
    ],
    // 750N Inner Wavy 100M ORG/ORG with NFP
    n750_wavy_100m_nfp: [
        { size: "4.0/40", code: "A132040C0100E", price: 63 }, { size: "5.0/50", code: "A132050C0100E", price: 102 },
        { size: "6.3/63", code: "A132063C0100E", price: 144 }
    ],
    // 750N Inner Plain 100M ORG/ORG with RR
    n750_plain_100m_rr: [
        { size: "4.0/40", code: "A122040C0100E", price: 66 }, { size: "5.0/50", code: "A122050C0100E", price: 102 },
        { size: "6.3/63", code: "A122063C0100E", price: 127 }
    ],
    // 750N Inner Plain 100M ORG/ORG with NFP
    n750_plain_100m_nfp: [
        { size: "4.0/40", code: "A128040C0100E", price: 69 }, { size: "5.0/50", code: "A128050C0100E", price: 107 },
        { size: "6.3/63", code: "A128063C0100E", price: 133 }
    ],
    // 750N Inner Plain 6M ORG/ORG with NFP
    n750_plain_6m_nfp: [
        { size: "4.0/40", code: "A128040C0006E", price: 73 }, { size: "5.0/50", code: "A128050C0006E", price: 112 },
        { size: "6.3/63", code: "A128063C0006E", price: 140 }, { size: "7.5/75", code: "A128075C0006E", price: 237 },
        { size: "7.7/77", code: "A128077C0006E", price: 237 }, { size: "9.0/90", code: "A128090C0006E", price: 264 },
        { size: "11.0/110", code: "A128110C0006E", price: 332 }, { size: "12.0/120", code: "A128120C0006E", price: 369 },
        { size: "16.0/160", code: "A128160C0006E", price: 662 }, { size: "17.5/175", code: "A128175C0006E", price: 702 },
        { size: "18.0/180", code: "A128180C0006E", price: 735 }, { size: "20.0/200", code: "A128200C0006E", price: 884 },
        { size: "25.0/250", code: "A128250C0006E", price: 1253 }, { size: "31.5/315", code: "A128315C0006E", price: 1791 }
    ],
    // 750N Inner Plain 6M ORG/ORG with RR & NFP
    n750_plain_6m_rr_nfp: [
        { size: "4.0/40", code: "A111040C0006E", price: 76 }, { size: "5.0/50", code: "A111050C0006E", price: 117 },
        { size: "6.3/63", code: "A111063C0006E", price: 146 }, { size: "7.5/75", code: "A111075C0006E", price: 247 },
        { size: "7.7/77", code: "A111077C0006E", price: 247 }, { size: "9.0/90", code: "A111090C0006E", price: 276 },
        { size: "11.0/110", code: "A111110C0006E", price: 347 }, { size: "12.0/120", code: "A111120C0006E", price: 385 },
        { size: "16.0/160", code: "A111160C0006E", price: 692 }, { size: "17.5/175", code: "A111175C0006E", price: 734 },
        { size: "18.0/180", code: "A111180C0006E", price: 768 }, { size: "20.0/200", code: "A111200C0006E", price: 925 },
        { size: "25.0/250", code: "A111250C0006E", price: 1310 }, { size: "31.5/315", code: "A111315C0006E", price: 1783 }
    ],
    // 450N Inner Wavy 100M ORG/ORG (basic)
    n450_wavy_100m_org: [
        { size: "4.0/40", code: "A103040C0100E", price: 37 }, { size: "5.0/50", code: "A103050C0100E", price: 57 },
        { size: "6.3/63", code: "A103063C0100E", price: 86 }
    ],
    // 450N Inner Plain 6M ORG/ORG (basic)
    n450_plain_6m_org: [
        { size: "4.0/40", code: "A102040C0006E", price: 41 }, { size: "5.0/50", code: "A102050C0006E", price: 66 },
        { size: "6.3/63", code: "A102063C0006E", price: 92 }, { size: "7.5/75", code: "A102075C0006E", price: 106 },
        { size: "7.7/77", code: "A102077C0006E", price: 114 }, { size: "9.0/90", code: "A102090C0006E", price: 143 },
        { size: "11.0/110", code: "A102110C0006E", price: 186 }, { size: "12.0/120", code: "A102120C0006E", price: 200 },
        { size: "16.0/160", code: "A102160C0006E", price: 320 }, { size: "17.5/175", code: "A102175C0006E", price: 391 },
        { size: "18.0/180", code: "A102180C0006E", price: 390 }, { size: "20.0/200", code: "A102200C0006E", price: 450 },
        { size: "25.0/250", code: "A102250C0006E", price: 675 }, { size: "31.5/315", code: "A102315C0006E", price: 995 }
    ],
    // 450N Inner Plain 100M BLK/BLK
    n450_plain_100m_blk: [
        { size: "4.0/40", code: "A102040C0100A", price: 39 }, { size: "5.0/50", code: "A102050C0100A", price: 68 },
        { size: "6.3/63", code: "A102063C0100A", price: 96 }
    ],
    // 450N Inner Plain 6M BLK/BLK
    n450_plain_6m_blk: [
        { size: "4.0/40", code: "A102040C0006A", price: 41 }, { size: "5.0/50", code: "A102050C0006A", price: 66 },
        { size: "6.3/63", code: "A102063C0006A", price: 92 }
    ],
    // 450N Inner Wavy 6M BLK/BLK
    n450_wavy_6m_blk: [
        { size: "4.0/40", code: "A103040C0006A", price: 37 }, { size: "5.0/50", code: "A103050C0006A", price: 57 },
        { size: "6.3/63", code: "A103063C0006A", price: 86 }
    ],
    // 450N Inner Wavy 100M BLK/BLK
    n450_wavy_100m_blk: [
        { size: "4.0/40", code: "A103040C0100A", price: 37 }, { size: "5.0/50", code: "A103050C0100A", price: 57 },
        { size: "6.3/63", code: "A103063C0100A", price: 86 }
    ],
    // 450N Inner Plain 6M ORG/ORG with RR
    n450_plain_6m_rr: [
        { size: "4.0/40", code: "A121040C0006E", price: 44 }, { size: "5.0/50", code: "A121050C0006E", price: 69 },
        { size: "6.3/63", code: "A121063C0006E", price: 97 }, { size: "7.5/75", code: "A121075C0006E", price: 111 },
        { size: "7.7/77", code: "A121077C0006E", price: 120 }, { size: "9.0/90", code: "A121090C0006E", price: 150 },
        { size: "11.0/110", code: "A121110C0006E", price: 195 }, { size: "12.0/120", code: "A121120C0006E", price: 210 },
        { size: "16.0/160", code: "A121160C0006E", price: 336 }, { size: "17.5/175", code: "A121175C0006E", price: 411 },
        { size: "18.0/180", code: "A121180C0006E", price: 410 }, { size: "20.0/200", code: "A121200C0006E", price: 473 },
        { size: "25.0/250", code: "A121250C0006E", price: 709 }, { size: "31.5/315", code: "A121315C0006E", price: 1045 }
    ],
    // 750N Inner Plain 100M ORG/ORG
    n750_plain_100m_org: [
        { size: "4.0/40", code: "A105040C0100E", price: 63 }, { size: "5.0/50", code: "A105050C0100E", price: 97 },
        { size: "6.3/63", code: "A105063C0100E", price: 121 }
    ],
    // 750N Inner Plain 6M ORG/ORG
    n750_plain_6m_org: [
        { size: "4.0/40", code: "A105040C0006E", price: 63 }, { size: "5.0/50", code: "A105050C0006E", price: 97 },
        { size: "6.3/63", code: "A105063C0006E", price: 121 }, { size: "7.5/75", code: "A105075C0006E", price: 205 },
        { size: "7.7/77", code: "A105077C0006E", price: 205 }, { size: "9.0/90", code: "A105090C0006E", price: 229 },
        { size: "11.0/110", code: "A105110C0006E", price: 288 }, { size: "12.0/120", code: "A105120C0006E", price: 319 },
        { size: "16.0/160", code: "A105160C0006E", price: 573 }, { size: "17.5/175", code: "A105175C0006E", price: 608 },
        { size: "18.0/180", code: "A105180C0006E", price: 636 }, { size: "20.0/200", code: "A105200C0006E", price: 766 },
        { size: "25.0/250", code: "A105250C0006E", price: 1085 }, { size: "31.5/315", code: "A105315C0006E", price: 1476 }
    ],
    // 750N Inner Plain 6M ORG/ORG with RR
    n750_plain_6m_rr: [
        { size: "4.0/40", code: "A122040C0006E", price: 66 }, { size: "5.0/50", code: "A122050C0006E", price: 102 },
        { size: "6.3/63", code: "A122063C0006E", price: 127 }, { size: "7.5/75", code: "A122075C0006E", price: 215 },
        { size: "7.7/77", code: "A122077C0006E", price: 215 }, { size: "9.0/90", code: "A122090C0006E", price: 240 },
        { size: "11.0/110", code: "A122110C0006E", price: 302 }, { size: "12.0/120", code: "A122120C0006E", price: 335 },
        { size: "16.0/160", code: "A122160C0006E", price: 602 }, { size: "17.5/175", code: "A122175C0006E", price: 638 },
        { size: "18.0/180", code: "A122180C0006E", price: 668 }, { size: "20.0/200", code: "A122200C0006E", price: 804 },
        { size: "25.0/250", code: "A122250C0006E", price: 1139 }, { size: "31.5/315", code: "A122315C0006E", price: 1550 }
    ]
};

export const formatPrice = (p) => p ? `₹${p.toFixed(2)}` : 'N/A';

export const getAllTelerexProducts = () => {
    const all = [];
    const types = {
        'n450_wavy_100m_rr': '450N Wavy 100M RR', 'n450_wavy_100m_nfp': '450N Wavy 100M NFP',
        'n450_plain_100m_rr': '450N Plain 100M RR', 'n450_plain_100m_nfp': '450N Plain 100M NFP',
        'n450_plain_6m_nfp': '450N Plain 6M NFP', 'n450_plain_6m_rr_nfp': '450N Plain 6M RR+NFP',
        'n750_wavy_100m_rr': '750N Wavy 100M RR', 'n750_wavy_100m_nfp': '750N Wavy 100M NFP',
        'n750_plain_100m_rr': '750N Plain 100M RR', 'n750_plain_100m_nfp': '750N Plain 100M NFP',
        'n750_plain_6m_nfp': '750N Plain 6M NFP', 'n750_plain_6m_rr_nfp': '750N Plain 6M RR+NFP',
        'n450_wavy_100m_org': '450N Wavy 100M', 'n450_plain_6m_org': '450N Plain 6M',
        'n450_plain_100m_blk': '450N Plain 100M BLK', 'n450_plain_6m_blk': '450N Plain 6M BLK',
        'n450_wavy_6m_blk': '450N Wavy 6M BLK', 'n450_wavy_100m_blk': '450N Wavy 100M BLK',
        'n450_plain_6m_rr': '450N Plain 6M RR', 'n750_plain_100m_org': '750N Plain 100M',
        'n750_plain_6m_org': '750N Plain 6M', 'n750_plain_6m_rr': '750N Plain 6M RR'
    };
    Object.keys(types).forEach(k => {
        telerexCatalog[k]?.forEach((item, i) => {
            all.push({ id: `${k}-${i}`, ...item, type: types[k], category: k });
        });
    });
    return all;
};

export const getTelerexSizes = () => [...new Set(getAllTelerexProducts().map(p => p.size))].sort((a, b) => parseFloat(a) - parseFloat(b));
export const getTelerexTypes = () => [...new Set(getAllTelerexProducts().map(p => p.type))];
